// GET /grades~GetGroupTree?LicGUID=49EBB9FC4EB368FC77C66BB4D6B13DC6&ObjType=0&SectionID=145&Info=0&UsedDate=0&ObjRef=0

import SplitterLocal from "../../../../Tools/Splitter";
import React, { useEffect, useRef, useState } from "react";
import Tree from "../../../../Windows/ViewData/Tree/Tree";
import { GridLoader } from "../../../../rcsgrid/createGridTools";
import {
  getColumns1,
  getColumns2,
  getDefaultFields1,
  getDefaultFields2,
  getGradesText,
  getRecords1,
  getRecords2,
} from "./localGroupGridData";
import { getDefaultMenu, updateGridData } from "../../../../Tools/Tools";
import ContextMenu from "../../../../NotWorkArea(Side&Head)/ContextMenu";
import { createGrid, createRecordSource } from "../../../../rcsgrid/rcsgrid";
import smetaAxios from "../../../../../SmetaAxios";
import { Prefixes } from "../../../../Tools/ProjectX";
import dialogStyles from "../dialogStyles.module.css";
import clsx from "clsx";

/**
 * Запрос данных для таблиц
 *
 * @param {string|number} groupId ID группы каталога
 * @param {string} department ID подразделения
 * @returns Данные для таблиц по группе и подразделению
 */
const getGradeScope = (groupId: string | number, department: string) => {
  const params = {
    GroupID: groupId,
    Department: department,
  };
  const config = {
    prefix: Prefixes.grade,
    method: "GET",
    url: "GetGradeScope",
    params,
  };
  return smetaAxios(config);
};

/**
 * Пост-Запрос на редактирование записи
 *
 * @param {Object} reqData объект с данными редактирования записи
 * @param {string} [reqData.ID] ID редактируемой записи
 * @param {string|number} [reqData.GroupID] ID группы таблицы
 * @param {string} [reqData.Info] поле Дополнительно
 * @param {string} [reqData.StartRange] поле Начало
 * @param {string} [reqData.EndRange] поле Конец
 * @param {string} [reqData.FirstDate]  поле От
 * @param {string} [reqData.LastDate]  поле До
 * @param {string} [reqData.Value] поле Значение
 * @param {string} [reqData.OrgTypeClsName] поле Учреждение
 * @param {string} [reqData.Options] опции редактирования
 * @param {string} [reqData.Status] статус записи
 *
 * @returns возвращает данные отредактированной записи
 */
const changeGradeValue = (reqData: {
  ID?: string;
  GroupID?: string | number;
  Info?: string;
  StartRange?: string;
  EndRange?: string;
  FirstDate?: string;
  LastDate?: string;
  Value?: string;
  Options?: string;
  OrgTypeClsName?: string;
  Status?: string;
}) => {
  const params = {
    ID: reqData.ID || "0",
    GroupID: reqData.GroupID,
    Department: reqData.Info || "0",
    StartRange: reqData.StartRange || "0",
    EndRange: reqData.EndRange || "0",
    FirstDate: reqData.FirstDate || "0",
    LastDate: reqData.LastDate || "0",
    Value: reqData.Value || "0",
    Options: reqData.Options || "0",
    OrgTypeCls: reqData.OrgTypeClsName || "0",
    Status: reqData.Status || "4",
  };
  const config = {
    prefix: Prefixes.grade,
    method: "GET",
    url: "ChangeGradeValue",
    params,
  };
  return smetaAxios(config);
};

/**
 * Запрос восстановления данных для текущей группы из конфигурации
 *
 * @param groupId - ID группы для восстановления
 */
const restoreGrade = (groupId: string | number) => {
  const params = {
    ID: groupId,
  };
  const config = {
    prefix: Prefixes.grade,
    method: "GET",
    url: "RestoreGrade",
    params,
  };
  return smetaAxios(config);
};

/**
 * Контент для детализации окладов подразделения
 *
 * Поля компонента:
 *    1. [groupID, setGroupID] - ID группы (хук состояния)
 *    2. [title, setTitle] - заголовок таблицы оклада (хук состояния)
 *    3. [gridPeriod, setGridPeriod] - объект таблицы Период (хук состояния)
 *    4. [gridData, setGridData] - объект таблицы Данные (хук состояния)
 *    5. [selectedRecordPeriodID, setSelectedRecordPeriodID] - ID текущей записи в таблице Периода (хук состояния)
 *    6. [selectedRecordDataID, setSelectedRecordDataID] - ID текущей записи в таблице Данных (хук состояния)
 *    7. [needPost, setNeedPost] - обновлене записи через обмен данными с сервером (хук состояния)
 *    8. data - данные для таблиц
 *    9. recordsPeriod - записи таблицы Период
 *    10. recordsData - записи таблицы Данные
 *    11. gridPanelPeriod - ссылка на панель таблицы Период
 *    12. gridPanelData - ссылка на панель таблицы Данные
 *    13. treeRef - ссылка на дерево
 *
 * @param {Object} props
 * @param {string} [props.Department] ID подразделения
 * @returns Возвращает компонент для детализации
 */
export default function GradesGrid({ props }: any): React.JSX.Element {
  const [groupID, setGroupID] = useState<string | number>(0);

  const [title, setTitle] = useState(null);

  const [gridPeriod, setGridPeriod] = useState<{ grid: createGrid; source: createRecordSource }>();
  const [gridData, setGridData] = useState<{ grid: createGrid; source: createRecordSource }>();

  const [selectedRecordPeriodID, setSelectedRecordPeriodID] = useState();
  const [selectedRecordDataID, setSelectedRecordDataID] = useState();
  const [needPost, setNeedPost] = useState<{ req: any; editFieldName: string; editFieldData: any } | null>(null);

  const data = useRef(props);

  const recordsPeriod = useRef<Array<{ [key: string]: string }>>([]);
  const recordsData = useRef<Array<{ [key: string]: string }>>([]);

  const gridPanelPeriod = useRef(null);
  const gridPanelData = useRef(null);
  const treeRef = useRef(null);

  /**
   * Загружает таблицу Период
   */
  const loadGridPeriod = async () => {
    setGridPeriod(
      await GridLoader(gridPanelPeriod.current, props, {
        localGrid: true,
        Columns: getColumns1(),
        defaultFields: getDefaultFields1(),
        keyField: "ID",
        getRecords: () => recordsPeriod.current,
        recordKeys: ["ID", "UsedDate", "Text"],
        titleKey: "Text",
        setSelectedRecord: setSelectedRecordPeriodID,
        showIndicator: false,
        Rights: "0",
      }),
    );
  };

  /**
   * Загружает таблицу Данные
   */
  const loadGridData = async () => {
    setGridData(
      await GridLoader(gridPanelData.current, props, {
        localGrid: true,
        Columns: getColumns2(),
        defaultFields: getDefaultFields2(),
        keyField: "ID",
        getRecords: () => recordsData.current,
        getFieldText: getGradesText,
        onPostRecord: onPostRecord,
        recordKeys: [
          "ID",
          "StartRange",
          "EndRange",
          "FirstDate",
          "Value",
          "Info",
          "LastDate",
          "OrgTypeClsName",
          "OrgTypeCls",
        ],
        titleKey: "StartRange",
        setSelectedRecord: setSelectedRecordDataID,
        showIndicator: false,
        Rights: "-1",
      }),
    );
  };

  /**
   * Инициализация таблиц
   */
  const initTables = () => {
    loadGridPeriod();
    loadGridData();
  };
  useEffect(initTables, []);

  /**
   * Обновление таблиц при изменении пропсов
   */
  const updateTables = () => {
    updatePeriods();
  };
  useEffect(updateTables, [props]);

  /**
   * Обновление таблиц при изменении группы в дереве
   */
  const onChangeGroupId = () => {
    if (groupID !== undefined) {
      updatePeriods();

      if (treeRef.current) {
        let info = treeRef.current.getCurrentInfo(groupID);
        if (info.title) setTitle(info.title);
      }
    }
  };
  useEffect(onChangeGroupId, [groupID]);

  /**
   * Обновление таблиц при изменении записи в периоде
   */
  const onChangePeriodID = () => {
    if (gridPeriod && selectedRecordPeriodID !== undefined) {
      recordsData.current = getRecords2(data.current, selectedRecordPeriodID);

      updateDataGrid();
    }
  };
  useEffect(onChangePeriodID, [selectedRecordPeriodID]);

  /**
   * Пост-обновление записи при редактировании
   */
  const postDataUpdate = () => {
    if (needPost) {
      postRecord(needPost);
      setNeedPost(null);
    }
  };
  useEffect(postDataUpdate, [needPost]);

  /**
   * Возвращает данные для таблиц
   *
   * @param groupID ID группы
   * @param department ID подразделения
   * @returns Возвращает данные для таблиц Период и Данные
   */
  const getData = async (groupID: string | number, department: string) => {
    const json: any = await getGradeScope(groupID, department);

    if (json.items && json.items.length) {
      const innerRecords: Array<Array<{ [key: string]: any }>> = json.items.map(
        (item: { items: Array<{ [key: string]: string }> }) => {
          return item.items;
        },
      );
      return { ...json, innerRecords };
    }

    return json;
  };

  /**
   * Обновляет все данные целиком
   */
  const updatePeriods = async () => {
    data.current = await getData(groupID, props.Department);
    recordsPeriod.current = getRecords1(data.current);
    recordsData.current = getRecords2(data.current, selectedRecordPeriodID || 0);
    await updatePeriodsGrid();
    await updateDataGrid();
  };

  /**
   * Обновляет таблицу Период
   */
  const updatePeriodsGrid = async () => {
    gridPeriod?.grid.refreshSource();
  };

  /**
   * Обновляет таблицу Данные
   */
  const updateDataGrid = async () => {
    gridData?.grid.refreshSource();
  };

  /**
   * При редактировании инициирует пост-обновление записи в таблице Данные
   *
   * @param {Object} req запрос от таблицы
   * @param {Object} recData данные редактирования от таблицы
   * @param {Object} postData дополнительные данные
   */
  const onPostRecord = async (req: any, recData: any, postData: any) => {
    const editFieldName = req.RecordSet.Attributes[0];
    let editFieldData;
    if (typeof recData[0] === "object") {
      if (recData[0].id) {
        editFieldData = recData[0].id;
      } else {
        editFieldData = recData[0].text;
      }
    } else {
      editFieldData = recData[0];
    }

    setNeedPost({ req, editFieldName, editFieldData });
  };

  /**
   * Отправляет данные редактирования на сервер и обновляет с новыми данными таблицу
   *
   * @param {Object} postData данные редактирования
   */
  const postRecord = async (postData: { req: any; editFieldName: string; editFieldData: any }) => {
    const result = {
      ...recordsData.current[postData.req.RecordIndex],
      [postData.editFieldName]: postData.editFieldData,
      GroupID: groupID,
    };

    const res = await changeGradeValue(result);
    if (res && res.items) {
      const innerRecords: Array<Array<{ [key: string]: any }>> = res.items.map(
        (item: { items: Array<{ [key: string]: string }> }) => {
          return item.items;
        },
      );
      data.current = { ...res, innerRecords };
      recordsData.current = getRecords2(data.current, selectedRecordPeriodID || 0);
    }

    updateDataGrid();
  };

  /**
   * Востанавливает таблицу из конфигурации
   */
  const configRestore = async () => {
    await restoreGrade(groupID);
    const res = await getGradeScope(groupID, props.Department);
    const innerRecords: Array<Array<{ [key: string]: any }>> = res.items.map(
      (item: { items: Array<{ [key: string]: string }> }) => {
        return item.items;
      },
    );
    data.current = { ...res, innerRecords };
    recordsData.current = getRecords2(data.current, selectedRecordPeriodID || 0);
  };

  /**
   * Обрабатывает команды контекстного меню
   *
   * @param contextData данные контекстного меню
   */
  const ContextMenuHandler = async (contextData: any) => {
    const comand = contextData.value;

    const comands: { [key: string]: () => void | Promise<void> } = {
      ConfigRestore: configRestore,
    };

    comands[comand]?.();
  };

  return (
    <div className={clsx(dialogStyles.fullDialogSpaceContainer)}>
      <SplitterLocal
        onResizeEnd={() => updateGridData(0)}
        onCollapse={() => updateGridData(0)}
        onExpand={() => updateGridData(0)}
        orientation="vertical"
        style={{ width: "100%", height: "100%" }}
        primaryIndex={1}
        defaultCollapsed={false}
        transitionDuration={250}
      >
        <div className={clsx(dialogStyles.fullDialogHeightContainer)}>
          <Tree
            props={{
              Module: "grades",
              SectionID: "145",
              multiCheck: false,
              ObjType: "0",
              Current: groupID,
              ObjRef: groupID,
              selectID: setGroupID,
              UsedDate: "0",
              Info: "0",
              ref: treeRef,
            }}
          />
        </div>
        <div className={clsx(dialogStyles.dialogLocalGroupGridTablesContainer)}>
          <div className={clsx(dialogStyles.dialogLocalGroupGridTitle)}>{title}</div>
          <SplitterLocal
            onResizeEnd={() => updateGridData(0)}
            onCollapse={() => updateGridData(0)}
            onExpand={() => updateGridData(0)}
            orientation="vertical"
            style={{ width: "100%", height: "100%" }}
            primaryIndex={1}
            defaultCollapsed={false}
            transitionDuration={250}
          >
            <div
              id={`rcgrid_panel`}
              ref={gridPanelPeriod}
              style={{
                height: "100%",
                width: "100%",
                position: "relative",
              }}
            ></div>

            <ContextMenu for={"grid"} Menu={getDefaultMenu("grades")} onMenuItemClick={ContextMenuHandler}>
              <div
                id={`rcgrid_panel`}
                ref={gridPanelData}
                style={{
                  height: "100%",
                  width: "100%",
                  position: "relative",
                }}
              ></div>
            </ContextMenu>
          </SplitterLocal>
        </div>
      </SplitterLocal>
    </div>
  );
}
